import { gsap } from 'gsap';

export function psMobileMenu() {
    const panel = document.getElementById('fullscreen-menu');
    if (!panel || !panel.classList.contains('promoter-socials-mobile-menu')) return;

    const page = document.querySelector('.page-wrapper');
    const openToggles = document.querySelectorAll('.promoter-socials-burger');
    const closeBtn = panel.querySelector('[data-ps-close]');
    const links = panel.querySelectorAll('.promoter-socials-menu--mobile > .menu-item em a');
    const cta = panel.querySelector('.promoter-socials-mobile-menu__cta');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let open = false;

    // Initial states
    gsap.set(panel, { x: '100%' });
    gsap.set(closeBtn, { scale: 0 });
    gsap.set(links, { yPercent: 110 });
    if (cta) gsap.set(cta, { opacity: 0 });

    function setA11y(isOpen) {
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        panel.toggleAttribute('inert', !isOpen);
        panel.classList.toggle('open', isOpen);
        document.body.classList.toggle('overflow-hidden', isOpen);
        openToggles.forEach((t) => {
            t.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            t.classList.toggle('is-open', isOpen);
        });
    }

    function openMenu() {
        if (open) return;
        open = true;
        setA11y(true);

        const dur = reduce ? 0 : 0.75;
        const tl = gsap.timeline();

        // Push: page left, panel right→in (simultaneous)
        if (page) tl.to(page, { xPercent: -8, duration: dur, ease: 'power3.inOut' }, 0);
        tl.to(panel, { x: 0, duration: dur, ease: 'power3.inOut' }, 0);

        // Wait for panel to arrive, then animate elements
        tl.to(closeBtn, { scale: 1, duration: reduce ? 0 : 0.5, ease: 'back.out(1.7)' }, '>');
        tl.to(links, { yPercent: 0, duration: reduce ? 0 : 0.65, ease: 'power3.out', stagger: 0.08 }, '<');
        if (cta) tl.to(cta, { opacity: 1, duration: reduce ? 0 : 0.45, ease: 'power3.out' }, '>-0.1');
    }

    function closeMenu() {
        if (!open) return;
        open = false;

        const dur = reduce ? 0 : 0.55;
        const tl = gsap.timeline({
            onComplete: () => {
                setA11y(false);
                // Reset for next open
                gsap.set(links, { yPercent: 110 });
                if (cta) gsap.set(cta, { opacity: 0 });
                gsap.set(closeBtn, { scale: 0 });
                if (page) gsap.set(page, { clearProps: 'xPercent' });
                gsap.set(panel, { x: '100%' });
            },
        });

        // Close button and CTA exit immediately
        tl.to(closeBtn, { scale: 0, duration: reduce ? 0 : 0.2, ease: 'power2.in' }, 0);
        if (cta) tl.to(cta, { opacity: 0, duration: reduce ? 0 : 0.25, ease: 'power2.in' }, 0);

        // Links exit last so > correctly waits for all of them
        tl.to(links, {
            yPercent: 110,
            duration: reduce ? 0 : 0.3,
            ease: 'power2.in',
            stagger: { amount: 0.2, from: 'end' },
        }, 0);

        // Panel and page slide back only after all links have finished
        tl.to(panel, { x: '100%', duration: dur, ease: 'power3.inOut' }, '>');
        if (page) tl.to(page, { xPercent: 0, duration: dur, ease: 'power3.inOut' }, '<');
    }

    openToggles.forEach((t) => t.addEventListener('click', openMenu));
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    panel.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && open) closeMenu();
    });

    window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
        if (e.matches && open) closeMenu();
    });
}
